import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useMemo, useRef, useState, useEffect } from 'react';
import cn from 'classnames';
import { getTestIds } from '../../utils/TestIds';
import { useBiAction } from '../BiTracking';
import styles from './SegmentControl.module.scss';
export const GetSegmentControlTID = (parentTestId)=>getTestIds(parentTestId);
export function SegmentControl(param) {
    let { options, value, onChange, variant = 'text', className, testId, bi, noBi: _noBi, 'aria-label': ariaLabel } = param;
    const { SegmentControlTID } = useMemo(()=>GetSegmentControlTID(testId), [
        testId
    ]);
    const containerRef = useRef(null);
    const segmentRefs = useRef([]);
    const [isInitialized, setIsInitialized] = useState(false);
    const logBiAction = useBiAction();
    const fireBi = useCallback((selectedValue)=>{
        if (bi === null || bi === void 0 ? void 0 : bi.name) {
            logBiAction({
                entityType: 'segment_control',
                entityName: bi.name,
                actionType: 'select',
                data: _object_spread_props(_object_spread({}, bi.data), {
                    test_id: testId !== null && testId !== void 0 ? testId : '',
                    selected_value: String(selectedValue)
                })
            });
        }
    }, [
        bi,
        logBiAction,
        testId
    ]);
    const selectedIndex = options.findIndex((opt)=>opt.value === value);
    const optionCount = options.length;
    const pillStyle = selectedIndex >= 0 && optionCount > 0 ? {
        left: "".concat(selectedIndex / optionCount * 100, "%"),
        width: "".concat(1 / optionCount * 100, "%"),
        visibility: 'visible'
    } : {
        left: '0%',
        width: '0%',
        visibility: 'hidden'
    };
    useEffect(()=>{
        if (!isInitialized) {
            requestAnimationFrame(()=>{
                setIsInitialized(true);
            });
        }
    }, [
        isInitialized
    ]);
    const handleKeyDown = (event, index)=>{
        let newIndex = index;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
            event.preventDefault();
            newIndex = (index + 1) % optionCount;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
            event.preventDefault();
            newIndex = (index - 1 + optionCount) % optionCount;
        } else if (event.key === 'Home') {
            event.preventDefault();
            newIndex = 0;
        } else if (event.key === 'End') {
            event.preventDefault();
            newIndex = optionCount - 1;
        }
        if (newIndex !== index) {
            var _segmentRefs_current_newIndex;
            fireBi(options[newIndex].value);
            onChange(options[newIndex].value);
            (_segmentRefs_current_newIndex = segmentRefs.current[newIndex]) === null || _segmentRefs_current_newIndex === void 0 ? void 0 : _segmentRefs_current_newIndex.focus();
        }
    };
    return /*#__PURE__*/ _jsxs("div", {
        ref: containerRef,
        className: cn(styles.container, className),
        "data-testid": SegmentControlTID.Root(),
        role: "radiogroup",
        "aria-label": ariaLabel,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: cn(styles.pill, isInitialized && styles.animated),
                style: {
                    left: pillStyle.left,
                    width: pillStyle.width,
                    visibility: pillStyle.visibility
                },
                "aria-hidden": "true",
                role: "presentation"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.segmentsWrapper,
                children: options.map((option, index)=>{
                    const isSelected = option.value === value;
                    const segmentClass = variant === 'icon' ? styles.iconSegment : styles.textSegment;
                    return /*#__PURE__*/ _jsx("button", {
                        ref: (el)=>{
                            segmentRefs.current[index] = el;
                        },
                        type: "button",
                        role: "radio",
                        "aria-checked": isSelected,
                        tabIndex: isSelected ? 0 : -1,
                        className: cn(styles.segment, segmentClass, isSelected && styles.selected),
                        onClick: ()=>{
                            if (option.value !== value) {
                                fireBi(option.value);
                                onChange(option.value);
                            }
                        },
                        onKeyDown: (e)=>handleKeyDown(e, index),
                        "data-testid": option.testId,
                        children: variant === 'icon' ? option.icon : option.label
                    }, option.value);
                })
            })
        ]
    });
}
